<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Yeni Slider Ekle">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span>
                <strong>Not:</strong> Eklenecek popup sadece belirli tarihler arası mevcut
                dil için 1 adet olabilir. Tarih TSİ olarak kaydedilmektedir. Tüm çeviriler
                için ayrı ayrı görsel eklemeniz gerekmektedir.
              </span>
            </div>
          </b-alert>
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            to="/popups/home"
          >
            Popup Listesi
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Popup Ekleme Formu">
            <b-row>
              <b-col cols="12">
                <b-form-group label="Başlık" label-for="title">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true, max: chars.title }"
                    name="Başlık"
                  >
                    <b-form-input
                      id="title"
                      v-model="title"
                      placeholder="Başlık"
                      :state="errors.length > 0 ? false : null"
                      :class="title.length >= chars.title ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="title.length >= chars.title ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ title.length }}</span>
                      /
                      {{ chars.title }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group label="Başlangıç Tarihi" label-for="startDate">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true, max: chars.title }"
                    name="Başlangıç Tarihi"
                  >
                    <b-form-datepicker
                      id="startDate"
                      v-model="startDate"
                      v-bind="translation || {}"
                      :locale="locale"
                      :start-weekday="weekday"
                      :show-decade-nav="showDecadeNav"
                      :hide-header="hideHeader"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Başlangıç Saati" label-for="startTime">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true, max: chars.title }"
                    name="Başlangıç Saati"
                  >
                    <b-form-timepicker
                      id="startTime"
                      class="form-control"
                      v-model="startTime"
                      placeholder="Bir saat seçin"
                      local="tr"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group label="Bitiş Tarihi" label-for="finishDate">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Başlangıç Tarihi"
                  >
                    <b-form-datepicker
                      id="finishDate"
                      v-model="finishDate"
                      v-bind="translation || {}"
                      :locale="locale"
                      :start-weekday="weekday"
                      :show-decade-nav="showDecadeNav"
                      :hide-header="hideHeader"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Bitiş Saati" label-for="finishTime">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Bitiş Saati"
                  >
                    <b-form-timepicker
                      id="finishTime"
                      class="form-control"
                      v-model="finishTime"
                      placeholder="Bir saat seçin"
                      local="tr"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <DragDropImage
                  ref="refCardImageMobile"
                  title="Mobil Popup Görseli"
                  :imageUrl="null"
                  :required="true"
                  featuredImageSize="400x700.png"
                >
                </DragDropImage>
              </b-col>
              <b-col md="8">
                <DragDropImage
                  ref="refCardImageDesktop"
                  title="Masaüstü Popup Görseli"
                  :imageUrl="null"
                  :required="true"
                  featuredImageSize="1264x610.png"
                >
                </DragDropImage>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="mt-5"></b-col>
              <b-col md="6" class="mt-5">
                <b-button
                  class="float-right mt-2"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-success"
                  @click="postConfirmText(false)"
                >
                  <b-spinner v-if="spinner === true && isDraft === false" small />
                  {{ spinner === true && isDraft === false ? "Yayınlanıyor" : "Yayınla" }}
                </b-button>
                <b-button
                  class="float-right mt-2 mr-1"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-warning"
                  @click="postConfirmText(true)"
                >
                  <b-spinner v-if="spinner == true && isDraft == true" small />
                  {{
                    spinner == true && isDraft == true
                      ? "Taslağa Kaydediliyor"
                      : "Taslağa Kaydet"
                  }}
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import DragDropImage from "../components/DragDropImage";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import {
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormTimepicker,
  BLink,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  max,
  digits,
  alphaDash,
  length,
} from "@validations";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    DragDropImage,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormTimepicker,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    max,
    digits,
    alphaDash,
    length,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      title: "",
      image: null,
      isDraft: false,
      startDate: null,
      startTime: null,
      finishDate: null,
      finishTime: null,
      chars: {
        title: 1000,
      },
      snowOption: {
        theme: "snow",
      },
      spinner: false,
      locale: "tr-TR",
      showDecadeNav: false,
      hideHeader: false,
      weekday: 0,
      translation: {
        labelPrevDecade: "Önceki on yıl",
        labelPrevYear: "Geçen yıl",
        labelPrevMonth: "Geçen ay",
        labelCurrentMonth: "İçinde bulunduğumuz ay",
        labelNextMonth: "Gelecek ay",
        labelNextYear: "Gelecek yıl",
        labelNextDecade: "Gelecek on yıl",
        labelToday: "Bugün",
        labelSelected: "Seçilen Tarih",
        labelNoDateSelected: "Tarih seçilmedi",
        labelCalendar: "Takvim",
        labelNav: "Takvimde gezinme",
        labelHelp: "Takvimde gezinmek için ok tuşlarını kullanın",
        labelHours: "Saat",
        labelMinutes: "Dakika",
        labelSeconds: "Saniye",
        labelIncrement: "Artır",
        labelDecrement: "Azalt",
        labelSelected: "Seçilen saat",
        labelNoTimeSelected: "Saat seçilmedi",
        labelCloseButton: "Seç",
      },
    };
  },

  methods: {
    postConfirmText(isDraft) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Kayıt?",
        text: "Yeni popupı kaydetmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },

    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          let formData = new FormData();

          formData.append("title", this.title);
          formData.append("isDraft", this.isDraft);
          formData.append("startDate", `${this.startDate} ${this.startTime}`);
          formData.append("finishDate", `${this.finishDate} ${this.finishTime}`);
          formData.append("imageMobile", this.$refs.refCardImageMobile.image);
          formData.append("imageDesktop", this.$refs.refCardImageDesktop.image);

          endpoints
            .postPopups(formData, this.$i18n.locale, () => {})
            .then((data) => {
              this.spinner = false;

              this.$swal({
                icon: "success",
                title: "Kayıt başarılı!",
                text: "Yeni popup eklendi.",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              }).then((result) => {
                if (result.value) {
                  this.$router.push({
                    path: `/popups`,
                  });
                }
              });
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },
  },
  created() {},
  destroyed() {},
  mounted() {
    localize("tr");
  },
  setup() {},
};
</script>
<style lang="css">
.ql-container {
  margin-top: 30px;
}

.ql-container,
.ql-editor {
  min-height: 300px !important;
  margin-bottom: 30px;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>
